var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "0 0 449.71 185",
    viewBox: "0 0 449.71 185",
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M448.66 184h-3.33V65.4l-22.1-17.88v135.14h-113.9V63.85l65.36-59.94 24.92 20.16 23.61-21.78v40.89l25.48 20.61Zm-136-4.71H419.8V44.79l-20.1-16.26-52.76 48.67v45.85h-3.37V75.73l.54-.5 52.94-48.85-22.27-18-62.12 57Zm89.55-153.07 17.59 14.23V10Z",
    fill: "#a68e68",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.66 185h-5.33V65.87l-20.1-16.26v134.05h-115.9V63.41l.33-.3 66-60.52 24.92 20.16L424.23 0v42.7l25.48 20.61Zm-3.38-2h1.38V64.26l-25.48-20.61V4.57l-22.57 20.82-24.92-20.16-64.4 59.06v117.37h111.89V45.42l24.1 19.5Zm-25.47-2.71H311.67V64.89l.32-.29 62.76-57.56 23.84 19.29-54 49.83v45.89h1.37V76.77l.32-.3 53.4-49.26 21.14 17.1Zm-107.14-2h105.14v-133l-19-15.41L348 77.67v46.41h-5.37V75.32l.86-.8 52.1-48.06-20.71-16.75-61.16 56.09ZM420.81 42.54l-20.12-16.27L420.81 7.7Zm-17.06-16.37 15.06 12.18V12.27Z",
    fill: "#a68e68",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a68e68",
    d: "M422.81 180.12h-3.38V141.3h-23.85v38.82h-3.38v-42.19h30.61z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.81 181.12h-5.37V142.3h-21.86v38.82h-5.37v-44.19h32.6Zm-3.37-2h1.37v-40.19h-28.6v40.19h1.37V140.3h25.86Z",
    fill: "#a68e68",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08 77.87 24.26 3.08h9.65l21 74.79h-6.52L28.99 7.38h.1L9.58 77.87Zm9.71-20.77v-5.5h32.59v5.5Z",
    fill: "#a68e68",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.42 77.87V3.33h6.26v72.52l-2.83-3.48h32.85v5.5Z",
    fill: "#a68e68",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.88 8.84 2.83-3.48v34.56l-1.61-2.22h30v5.56h-30l1.61-2.23v34.82l-2.83-3.48h35.78v5.5h-39.21V3.33h39.21v5.51Z",
    fill: "#a68e68",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249.64 38.46-.05 5.1L226.5 3.33h7l20.17 35.83h-4.1l20-35.83h7l-22.89 40.23-.05-5.1 23.7 39.41h-7L249.51 42.8h4.3l-20.88 35.07h-7Z",
    fill: "#a68e68",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27 181.79H0v-74.54h19.41q8.64 0 14.22 3.18a20.2 20.2 0 0 1 8.29 8.49 27.06 27.06 0 0 1-.07 23.75 21.36 21.36 0 0 1-8.39 8.77q-5.61 3.31-14.05 3.31H6.27Zm0-29.37-2.83-3.18h15.11a23 23 0 0 0 11.14-2.4 15.37 15.37 0 0 0 6.5-6.57 20.75 20.75 0 0 0 2.12-9.52 21 21 0 0 0-2-9.46 14.16 14.16 0 0 0-6.37-6.29q-4.35-2.25-11.37-2.25H3.46l2.83-3.48Z",
    fill: "#a68e68",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.9 107.25v74.54h-6.26v-37.5l2.83 3.13H73.38l2.83-3.13v37.5h-6.27v-74.54h6.27v37.9l-2.83-3.29h41.09l-2.83 3.29v-37.9Z",
    fill: "#a68e68",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.33 181.79 21.18-74.8h9.65l21 74.8h-6.52l-19.4-70.5h.1l-19.51 70.5Zm9.71-20.77v-5.51h32.59V161Z",
    fill: "#a68e68",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.92 107.25h10.72v74.54h-6v-69.54l.2.1-20.72 69.44h-9.1l-20.69-69.49.2-.1v69.59h-6v-74.54h10.71l20.42 69.74h-.2Z",
    fill: "#a68e68",
    "data-color": 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f220cf2f75c554e8285eaa895545abfe.svg";
export { ForwardRef as ReactComponent };